module.exports = __webpack_public_path__ + "static/media/background_1.7f91d0d8.png";